import React from 'react';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button'
import moment from 'moment';
import EntryCard from '../../components/my_portal/EntryCard';
import Loader from '../../components/common/Loader';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import { daysOfWeekFull, getDateRange } from '../../utilities/helper';
import Dialog from '../../utilities/Dialog'
//@ts-ignore
//!!r-18-dj
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppState } from '../../store';
//#region TYPE DEFINITIONS
interface Entry {
    TimeEntryID: number,
    EntryDate: string,
    Quantity: number,
    FieldTimeCodeID: number,
    ApprovedDate: string | null,
}

interface HourReferenceType {
    FieldTimeCodeID: number;
    CodeDescription: string;
    HRTimeCodeId: number;
    DepartmentID: number;
    IsUserEditable: number;
    CreatedBy: number;
    CreatedDate: Date | string | null;
    DeletedBy: string | number | null;
    DeletedDate: Date | string | null;
    DisabledBy: number | null;
    DisabledDate: Date | string | null;
    HelpText: string | null;
    IsAdminEditable: boolean;
    IsNonNumericEntryOnly: boolean;
    IsProductivePay: boolean;
    ListOrder: number;
    ModifiedBy: number;
    ModifyDate: Date | string | null;
    NonNumericCharacterCsv: any;
    PayrollHRTimeCodeID: number;
}

interface IProps {
    employeeId: string;
    profitCenterId: string | number;
}
//#endregion

const formattedToday: string = moment().format("M/DD/YYYY");

const Timesheet: React.FC<IProps> = (props: IProps) => {
    //#region STATE / VARIABLES
    const [loading, setLoading] = React.useState(false);
    // Key value pairs key being EntryDate and the data being an array of Entries corressponding to date
    const [groups, setGroups] = React.useState({} as any);
    // Array of date strings
    const [dates, setDates] = React.useState([] as Array<string | any>);
    // Current selected date
    const [selected, setSelected] = React.useState("" as string);
    const [selectedTotal, setSelectedTotal] = React.useState(0);
    const [mobileClassNames, setMobileClassNames] = React.useState("");
    const [total, setTotal] = React.useState(0);
    // Focus date is what the api/find week start end use to find given week
    const [focusDate, setFocusDate] = React.useState(moment().format("YYYY-MM-DD") + "T00:00:00");
    const [referenceTypes, setReferenceTypes] = React.useState([] as Array<HourReferenceType>);
    // Saves a copy of the original response everytime it is called
    const [originalResponse, setOriginalResponse] = React.useState([]);
    const [difference, setDifference] = React.useState(0);
    const [differenceDate, setDifferenceDate] = React.useState("");
    const [prevDay, setPrevDay] = React.useState("");
    const [nextDay, setNextDay] = React.useState("");
    const [nextNoData, setNextNoData] = React.useState(false);
    const [prevNoData, setPrevNoData] = React.useState(false);
    const [regularHoursId, setRegularHoursId] = React.useState(null as any);
    const [refreshKey, setRefreshKey] = React.useState(0);
    const [mobileGoingForward, setMobileGoingForward] = React.useState(false);
    const [isFormDirty, setIsFormDirty] = React.useState(false);
    const [validationMessages, setValidationMessages] = React.useState([] as any);
    let history: any = useHistory();
    //#endregion
    //#region METHODS / FUNCTIONS
    const getApprovedFromGroup = (group: any, prefix: string = "border"): string => {
        let isApproved: boolean = true;
        let cn: string = "";
        if (group === undefined || group === null || group?.length === 0 || !group) {
            isApproved = false;
            cn = prefix + "-dark"
            return cn;
        }
        // turn to reduce later
        group.forEach((entry: any) => {
            if (!entry.ApprovedDate) { //entry.Quantity !== 0
                isApproved = false;
            }
            // else if(entry.ApprovedDate && entry.Quantity === 0)
        });
        if (isApproved) { cn = prefix + "-darkgreen" } else { cn = prefix + "-danger" }
        return cn;
    }

    const handleSelect = (entryDate: string, e?: React.MouseEvent) => {
        e && e.preventDefault();
        // //console.log("Setting Selected : ", entryDate);
        // Setting Selected to selected date
        setSelected(entryDate);
        setValidationMessages([]);
        // Finding data associated with entryDate
        let selectedInfo: any = groups[entryDate];
        // If there is data associated with entryDate parse it
        if (selectedInfo) {
            // Finds total of all time entries associated with entry date
            let sTotal: number = selectedInfo?.reduce((acc: number, entry: Entry) => acc + entry.Quantity, 0);
            setSelectedTotal(sTotal);
            let classNames: string = getApprovedFromGroup(selectedInfo, "border");
            setMobileClassNames(classNames);
        } else { // No Data associated with entry date, default to 0 as quantity and border-dark for className
            setSelectedTotal(0);
            setMobileClassNames("border-dark");
        }
        history.push("/my-portal/timesheet/" + entryDate);
    }

    const handleCardClick = async (entryDate: string, e: React.MouseEvent) => {
        e.preventDefault();
        if (isFormDirty) {
            let c: any = new Dialog({});
            let answer: boolean = await c.show();
            if (!answer) {
                return;
            }
        }
        handleSelect(entryDate);
    }

    const jumpToToday = () => {
        handleSelect(formattedToday)
        //console.log(selected)
    }

    const findWeekStartEnd = (date: any = null, getReference: boolean = false): void => {
        // Will find the Friday and Saturday of supplied date
        getTimeSheetWeek(getReference);
        let now = date ? moment(date).toDate() : new Date();
        now.setHours(0, 0, 0, 0);
        // Gets closest Saturday to date. if it is a Saturday nothing changes
        let saturday = new Date(now);
        if (!(saturday.getDay() === 6)) { // day is not currently saturday
            let newDate = saturday.getDate() - (saturday.getDay() + 1);
            saturday.setDate(newDate);
        }
        // Adds 7 days to Saturday to get next Friday
        let friday = moment(saturday).add(7, "days").toDate();
        // Get an array of date strings with all days in between
        // //console.log("Dates getting passed to get range : ", saturday, friday);
        let range: Array<string> = getDateRange(saturday, friday, "M/DD/YYYY");
        setDates(range);
        // Choose a date to select as default, if todays date is included in the range it will select that
        if (!getReference) {
            let today: Date | string = new Date();
            today = moment(today).format("M/DD/YYYY");
            if (range.includes(today)) {
                handleSelect(today);
            } else {
                if (window.innerWidth > 1200) {
                    handleSelect(range[0]);
                } else {
                    // if mobile is going forward handleSelect for first day of week else get the last day of the week
                    mobileGoingForward ? handleSelect(range[0]) : handleSelect(range[range.length - 1]);
                }
            }
        }
    }

    const editEntryCallback = (date: string, newVal: string, difference: number = 0) => {
        setDifferenceDate(date);
        setDifference(difference);
    }

    const handleBack = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (isFormDirty) {
            let c: any = new Dialog({});
            let answer: boolean = await c.show();
            if (!answer) {
                return;
            }
            setIsFormDirty(false);
        }
        setMobileGoingForward(false);
        // Removes a week to current focus date
        let finalFocus: string = moment(focusDate).subtract(7, "day").format("YYYY-MM-DD") + "T00:00:00";
        setFocusDate(finalFocus);
    }

    const handleForward = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        if (isFormDirty) {
            let c: any = new Dialog({});
            let answer: boolean = await c.show();
            if (!answer) {
                return;
            }
            setIsFormDirty(false);
        }
        setMobileGoingForward(true);
        // Adds a week to focusDate
        // //console.log("Focus date before add : ", focusDate);
        let finalFocus: string = moment(focusDate).add(7, "days").format("YYYY-MM-DD") + "T00:00:00";
        // //console.log("Final Focus : ", finalFocus);
        setFocusDate(finalFocus);
    }

    const handleBackDay = async () => {
        if (isFormDirty) {
            let c: any = new Dialog({});
            let answer: boolean = await c.show();
            if (!answer) {
                return;
            }
            setIsFormDirty(false);
        }
        setMobileGoingForward(false);
        // Finds day before selected
        let prevDay: string = moment(selected, "M/DD/YYYY").subtract(1, "days").format("M/DD/YYYY");
        // If a user has reached the beginning of the week
        if (moment(selected, "M/DD/YYYY").format("M/DD/YYYY") === dates[0]) {
            // Find previous weeks start
            let prevWeekStart: string = moment(focusDate).subtract(7, "days").format("YYYY-MM-DD") + "T00:00:00";
            // Call focus date to fetch new weeks data
            setFocusDate(prevWeekStart);
        }
        // Has not reached end of week just set the value
        handleSelect(prevDay);
    }

    const handleForwardDay = async () => {
        if (isFormDirty) {
            let c: any = new Dialog({});
            let answer: boolean = await c.show();
            if (!answer) {
                return;
            }
            setIsFormDirty(false);
        }
        setMobileGoingForward(true)
        // Gets the next day after selected
        let nextDay: string = moment(selected, "M/DD/YYYY").add(1, "days").format("M/DD/YYYY");
        // checks if a user has reached end of the week
        if (moment(selected, "M/DD/YYYY").format("M/DD/YYYY") === dates[dates.length - 1]) {
            // Get next weeks start
            let nextWeekStart: string = moment(focusDate).add(7, "days").format("YYYY-MM-DD") + "T00:00:00";
            // call setFocusDate to fetch new weeks data
            setFocusDate(nextWeekStart);
        }
        // Already has data, just setting selected
        handleSelect(nextDay);
    }

    const createGroups = (timesheetData: Array<Entry>) => {
        let finalGroups: any = {};
        let totalHours: number = 0;
        timesheetData.forEach((entry: Entry) => {
            // Finds total hours for the week
            totalHours += entry.Quantity;
            // Groups data up by entryDate
            let entryDate: string = moment(entry.EntryDate).format("M/DD/YYYY");
            // pushes entry to finalGroups[entryDate] if it exists, else make an array with the entry
            finalGroups[entryDate] ? finalGroups[entryDate].push(entry) : finalGroups[entryDate] = [entry];
        });
        // //console.log("Set Groups Final : ", finalGroups);
        setTotal(totalHours);
        setGroups(finalGroups);
        setRefreshKey(refreshKey + 1);
    }

    const getTimeSheetWeek = (getReferenceData: boolean = false) => {
        setLoading(true);
        let date = moment(focusDate).format("YYYY-MM-DD") + "T00:00:00";
        let referenceRequest: any = axios.get(`${process.env.REACT_APP_API_URL}/api/MyPortal/GetTimeSheetReference?employeeid=${Number(props.employeeId)}`, AxiosConfig.configValue("min"));
        let weekRequest: any = axios.get(`${process.env.REACT_APP_API_URL}/api/MyPortal/GetTimeSheetWeek/?focusDateUtc=${date}&employeeId=${props.employeeId}`, AxiosConfig.configValue("min")); //T00:00:00
        if (getReferenceData) { // Getting Timesheet week and reference data
            axios.all([referenceRequest, weekRequest])
                .then((res: any) => {
                    let referenceRes: any = res[0];
                    let weekRes: any = res[1];
                    //console.log("Get Timesheet Week Response", weekRes);
                    setOriginalResponse(weekRes.data);
                    setReferenceTypes(referenceRes.data);
                    let rh: any = referenceRes.data.find((item: any) => item.CodeDescription === "Regular Hours");
                    setRegularHoursId(rh.FieldTimeCodeID);
                    createGroups(weekRes.data);
                })
                .catch((err: any) => {
                    //console.log("getTimeSheetWeek Error : ", err);
                    AxiosConfig.handleError(err);
                })
                .finally(() => setLoading(false))
        } else { // Just get the time sheet week
            axios.get(`${process.env.REACT_APP_API_URL}/api/MyPortal/GetTimeSheetWeek/?focusDateUtc=${date}&employeeId=${props.employeeId}`, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    // After getting data just call two setup functions
                    //console.log("GetTimeSheetWeek Response : ", res);
                    setOriginalResponse(res.data);
                    createGroups(res.data);
                })
                .catch((err: any) => {
                    //console.log(err);
                    AxiosConfig.handleError(err);
                })
                .finally(() => setLoading(false))
        }
    }

    const handleChangesCallback = (responses: Array<any>, validationMessages?: Array<string>) => {
        clearEdits();
        if (responses) {
            // Creates copy of original values
            let originalCopy: any = [...originalResponse];
            // Updating original objects
            responses.forEach((updatedEntry: any) => {
                let originalIndex: number = originalCopy.findIndex((entry: Entry) => entry.TimeEntryID === updatedEntry.TimeEntryID);
                if (originalIndex > -1) {
                    // deletes old entry
                    originalCopy.splice(originalIndex, 1);
                    // pushes new entry to array
                    originalCopy.push(updatedEntry);
                }
                else {
                    originalCopy.push(updatedEntry);
                }
            });
            // Set up groups with "new data"
            validationMessages && setValidationMessages(validationMessages);
            setOriginalResponse(originalCopy);
            createGroups(originalCopy);
        }
    }

    const clearEdits = () => {
        // Clears difference date and sets total difference to zero
        setIsFormDirty(false);
        setDifferenceDate("");
        setDifference(0);
    }

    const toggleDirty = (isDirty: boolean) => { setIsFormDirty(isDirty); }

    const refreshSelf = () => { findWeekStartEnd(focusDate, true); }
    //#endregion
    //#region USEEFFECTS
    React.useEffect(() => {
        // Finds new week when focus date changes
        focusDate && findWeekStartEnd(focusDate);
        // eslint-disable-next-line 
    }, [focusDate])

    React.useEffect(() => { // Set next and previous values when a selection is made
        // Getting date directly before and after focused date
        let prev: string = moment(selected).subtract(1, "days").format("M/DD/YYYY");
        let next: string = moment(selected).add(1, "days").format("M/DD/YYYY");
        // Setting no data to true if next/prev dates are not in the weeks range
        setPrevNoData(!dates.includes(prev));
        setNextNoData(!dates.includes(next));
        // Setting values
        setNextDay(next);
        setPrevDay(prev);
    }, [selected, dates])

    React.useEffect(() => {
        // Sets mobile classNames and mobile total
        if (selected && groups[selected]) {
            let finalGroups = groups[selected];
            let mobileTotal = finalGroups.reduce((acc: number, item: any) => acc += item.Quantity, 0);
            let classNames: string = getApprovedFromGroup(finalGroups, "border");
            setMobileClassNames(classNames);
            setSelectedTotal(mobileTotal);
        }
        // eslint-disable-next-line 
    }, [refreshKey])

    React.useEffect(() => {
        findWeekStartEnd();
        getTimeSheetWeek(true);
        // demoDialogs();
        // eslint-disable-next-line 
    }, [])
    // const demoDialogs = async () => {
    //     let p: any = new Dialog({ type: "prompt" });
    //     let value: string = await p.show();
    //     alert("Value : " + value);
    //     // let c: any = new ConfirmDialog({});
    //     // let answer: boolean = await c.confirm();
    // }
    //#endregion
    //#region RENDER
    return (
        <Col className="main-content" sm>
            {/* Header Content */}
            <div data-testid="top-header" className="w-100 d-flex flex-column flex-md-row justify-content-between py-1 px-2">
                <h2 className="border border-dark p-1 shadow d-none d-md-flex flex-column flex-md-row">Timesheet - Week Beginning {dates[0]}</h2>
                <h5 className="d-block d-md-none border border-dark p-1 shadow text-center">Week Start: {dates[0]}</h5>
                <h3 className="border border-dark p-1 shadow d-none d-md-block">Total Hours: {total + difference}</h3>
                <h5 className="border border-dark p-1 shadow d-block d-md-none text-center">Total Week Hours: {total + difference}</h5>
            </div>
            {/* End Header Content */}

            {/* Desktop Controls */}
            <div
                className="d-none d-md-flex flex-row justify-content-between align-items-center pt-1 px-2 no-vertical mb-5 pb-2 pt-1 border-bottom shadow-sm"
                style={{ overflowX: "scroll" }}
            >
                <button data-testid="ctrls-prev-week" disabled={loading} onClick={handleBack} style={{ background: "none" }} className="material-icons border-0 flip-x cursor-on-hover h-100 w-5">double_arrow</button>
                {dates && dates.map((key: any) => {
                    let total: number = groups[key]?.reduce((acc: number, cur: Entry) => acc + cur.Quantity || 0, 0);
                    let finalTotal: string = total?.toFixed(2).toString() || "0"
                    if (finalTotal[finalTotal.length - 1] === "0") {
                        finalTotal = finalTotal.substring(0, finalTotal.length - 1);
                    }
                    if (differenceDate === key) {
                        finalTotal = `${Number(finalTotal) + difference}`;
                    }
                    let classNames: string = getApprovedFromGroup(groups[key]);
                    let cnOriginal: string = classNames;
                    let isApproved: boolean = (classNames === "border-darkgreen");
                    if (key === selected) {
                        classNames = "datePicker-selected"
                    }
                    if (key === formattedToday) {
                        classNames = classNames + " datePicker-today";
                    }
                    return (
                        <div
                            key={key}
                            onClick={(e: React.MouseEvent) => handleCardClick(key, e)}
                            className={`d-flex flex-column justify-content-center shadow rounded align-items-center border dateDisplay py-1 px-2 ${classNames}`}
                            style={{ width: 100, height: 80 }}
                        >
                            <h6 className="m-0">{daysOfWeekFull[moment(key, "M/DD/YYYY").isoWeekday()]}</h6>
                            <h6 className="m-0">{moment(key, "M/DD/YYYY").format("MM/DD")}</h6>
                            <hr className="m-0 w-100" />
                            {
                                cnOriginal !== "border-dark" ?
                                    <h4 className={`m-0 w-100 h-100 d-flex justify-content-center align-items-center text-white border border-dark ${isApproved ? "bg-darkgreen" : "bg-danger"}`}>
                                        {loading ? "Loading..." : finalTotal}
                                    </h4>
                                    :
                                    loading ? <h6>Loading...</h6> : <h4>{finalTotal ? finalTotal : 0}</h4>
                            }
                        </div>
                    )
                })}
                <button data-testid="ctrls-next-week" disabled={loading} onClick={handleForward} style={{ background: "none" }} className="material-icons border-0 cursor-on-hover h-100 w-5">double_arrow</button>
            </div>
            {/* End Desktop Controls */}

            {/* Mobile Controls */}
            <div className="d-flex d-md-none flex-row justify-content-between align-items-center px-2 mb-1">
                <div>
                    <button disabled={loading} onClick={handleBack} className="material-icons border-0 flip-x cursor-on-hover h-100 w-5 rounded-circle bg-dark text-white p-1 mr-3 timesheet-mobile-arrow">double_arrow</button>
                    <button disabled={loading} onClick={handleBackDay} className="material-icons border-0 flip-x cursor-on-hover h-100 rounded-circle bg-dark text-white p-1 timesheet-mobile-arrow">keyboard_arrow_right</button>
                </div>
                <div className={`d-flex flex-column justify-content-center align-items-center border p-1 ${mobileClassNames} ${moment(selected, "M/DD/YYYY").format("M/DD/YYYY") === formattedToday ? "datePicker-today" : ""}`}>
                    <h6>{moment(selected, "M/DD/YYYY").format("ddd MM/DD")}</h6>
                    <h6>Total Hours: {selectedTotal}</h6>
                </div>
                <div>
                    <button disabled={loading} onClick={handleForwardDay} className="material-icons border-0 cursor-on-hover h-100 rounded-circle bg-dark text-white p-1 mr-3 timesheet-mobile-arrow">keyboard_arrow_right</button>
                    <button disabled={loading} onClick={handleForward} className="material-icons border-0 cursor-on-hover h-100 w-5 rounded-circle bg-dark text-white p-1 timesheet-mobile-arrow">double_arrow</button>
                </div>
            </div>
            {/* End Mobile Controls */}

            {/* Time Entries */}
            <div className="d-flex flex-row justify-content-around align-items-center">
                {
                    loading
                        ?
                        <Loader title="Loading Timesheet" />
                        :
                        <>
                            <EntryCard // Left Preview Card
                                profitCenterId={props.profitCenterId}
                                employeeId={props.employeeId}
                                editCallback={editEntryCallback}
                                date={prevDay}
                                selected={groups[prevDay]}
                                reference={referenceTypes}
                                handleChangesCallback={handleChangesCallback}
                                clearEditsCallback={clearEdits}
                                isPreview
                                noData={prevNoData}
                                regularHoursId={regularHoursId}
                                clickCallback={handleBackDay}
                            />
                            <EntryCard // Editable entry card, main middle card
                                testid="entry-card"
                                key={selected + focusDate + refreshKey}
                                profitCenterId={props.profitCenterId}
                                employeeId={props.employeeId}
                                editCallback={editEntryCallback}
                                date={selected}
                                selected={groups[selected]}
                                reference={referenceTypes}
                                handleChangesCallback={handleChangesCallback}
                                clearEditsCallback={clearEdits}
                                regularHoursId={regularHoursId}
                                toggleDirty={toggleDirty}
                                validationMessages={validationMessages}
                                updateTimesheet={refreshSelf}
                            />
                            <EntryCard // Right Preview Card
                                profitCenterId={props.profitCenterId}
                                employeeId={props.employeeId}
                                editCallback={editEntryCallback}
                                date={nextDay}
                                selected={groups[nextDay]}
                                reference={referenceTypes}
                                handleChangesCallback={handleChangesCallback}
                                clearEditsCallback={clearEdits}
                                isPreview
                                noData={nextNoData}
                                regularHoursId={regularHoursId}
                                clickCallback={handleForwardDay}
                            />
                        </>
                }
            </div>
            <div className="jump-btn-wrapper">
                <Button onClick={jumpToToday}>Go to Today</Button>
            </div>
        </Col>
    );
    //#endregion
}

const mapStateToProps = (state: AppState) => ({
    employeeId: state.user.userId,
    profitCenterId: state.user.homeProfitCenter
});

export default connect(mapStateToProps)(Timesheet);